import { bookReducer } from './reducers';

export const { clearBook, initiateBook } = bookReducer.actions;
